import { render } from "./datasets.vue?vue&type=template&id=263bbef9&scoped=true"
import script from "./datasets.vue?vue&type=script&lang=js"
export * from "./datasets.vue?vue&type=script&lang=js"

import "./datasets.vue?vue&type=style&index=0&id=263bbef9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263bbef9"]])

export default __exports__